import React, { ReactNode, useMemo } from "react";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

interface SentryProviderProps {
  children: ReactNode;
}

export interface SentryUserProps {
  id?: string;
  email?: string;
  name?: string;
}

export const SentryProvider = ({ children }: SentryProviderProps) => {
  useMemo(
    () =>
      Sentry.init({
        dsn: SENTRY_DSN,
        environment: NODE_ENV || "development",
        integrations: [new BrowserTracing()],
        tracesSampleRate: 0,
      }),
    [],
  );

  return <Sentry.ErrorBoundary>{children}</Sentry.ErrorBoundary>;
};

export const useSentry = () => {
  return {
    notify: (err: unknown) => Sentry.captureException(err),
    setUser: (user: SentryUserProps) => Sentry.setUser(user),
  };
};
